import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Logo from '../../images/logo/logo.png';
import {useTranslation} from "react-i18next";
import {Image} from "react-bootstrap";
import {useAuth} from "../../context/AuthContext";

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const { pathname } = location;
  const { t } = useTranslation();
  const {hasRight} = useAuth()

  const trigger = useRef(null);
  const sidebar = useRef(null);

  const storedSidebarExpanded = localStorage.getItem('sidebar-expanded');
  const [sidebarExpanded] = useState(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true'
  );

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) {
        return;
      }
      if (
          !sidebarOpen ||
          sidebar.current.contains(target) ||
          trigger.current.contains(target)
      ) {
        return;
      }
      setSidebarOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  useEffect(() => {
    localStorage.setItem('sidebar-expanded', sidebarExpanded.toString());
    if (sidebarExpanded) {
      document.querySelector('body')?.classList.add('sidebar-expanded');
    } else {
      document.querySelector('body')?.classList.remove('sidebar-expanded');
    }
  }, [sidebarExpanded]);


  return (
      <nav
          id="sidebar"
          className={`sidebar${sidebarOpen ? '' : ' collapsed'}`}
          ref={sidebar}
      >
        <div className="sidebar-content sticky-top">
          <NavLink className="sidebar-brand" to="/">
            <Image src={Logo} alt="Logo" width="60%"/>
          </NavLink>

          <ul className="sidebar-nav">
            <li className={`sidebar-item${
                (pathname === '/' ||
                    pathname.includes('dashboard')) &&
                ' active'
            }`}>
              <NavLink
                  to="/"
                  className="sidebar-link"
              >
                <i className="fa-solid fa-gauge" style={{fontSize: '18px', width: '18px'}}></i>
                <span className="align-middle" style={{fontSize: '15px'}}>{t('layout.menu.dashboard')}</span>
              </NavLink>
            </li>
            {hasRight('tiers_payant') && <li className={`sidebar-item${
                (pathname === '/tiers-payant' ||
                    pathname.includes('tiers-payant')) &&
                ' active'
            }`}>
              <NavLink
                  to="/tiers-payant"
                  className="sidebar-link"
              >
                <i className="fa-solid fa-file-invoice-dollar" style={{fontSize: '18px', width: '18px', textAlign: 'center'}}></i>
                <span className="align-middle" style={{fontSize: '15px'}}>{t('layout.menu.tiers-payant')}</span>
              </NavLink>
            </li>}
            {hasRight('rejection') && <li className={`sidebar-item${
                (pathname === '/rejection' ||
                    pathname.includes('rejection')) &&
                ' active'
            }`}>
              <NavLink
                  to="/rejection"
                  className="sidebar-link"
              >
                <i className="fa-solid fa-file-lines" style={{fontSize: '18px', width: '18px', textAlign: 'center'}}></i>
                <span className="align-middle" style={{fontSize: '15px'}}>{t('layout.menu.rejection')}</span>
              </NavLink>
            </li>}
            {hasRight('user') && <li className={`sidebar-item${
                (pathname === '/user' ||
                    pathname.includes('user')) &&
                ' active'
            }`}>
              <NavLink
                  to="/user"
                  className="sidebar-link"
              >
                <i className="fa-solid fa-users" style={{fontSize: '18px', width: '18px'}}></i>
                <span className="align-middle" style={{fontSize: '15px'}}>{t('layout.menu.users')}</span>
              </NavLink>
            </li>}

            {hasRight('customer') && <li className={`sidebar-item${
                (pathname === '/customer' ||
                    pathname.includes('customer')) &&
                ' active'
            }`}>
              <NavLink
                  to="/customer"
                  className="sidebar-link"
              >
                <i className="fa-solid fa-hospital" style={{fontSize: '18px', width: '18px'}}></i>
                <span className="align-middle" style={{fontSize: '15px'}}>{t('layout.menu.customer')}</span>
              </NavLink>
            </li>}
            {hasRight('health_insurance') && <li className={`sidebar-item${
                (pathname === '/health-insurance' ||
                    pathname.includes('health-insurance')) &&
                ' active'
            }`}>
              <NavLink
                  to="/health-insurance"
                  className="sidebar-link"
              >
                <i className="fa-solid fa-money-check-dollar" style={{fontSize: '18px', width: '18px'}}></i>
                <span className="align-middle" style={{fontSize: '15px'}}>{t('layout.menu.health-insurance')}</span>
              </NavLink>
            </li>}
            <li className={`sidebar-item${
                (pathname === '/mailbox' ||
                    pathname.includes('mailbox')) &&
                ' active'
            }`}>
              <span
                  className="sidebar-link"
              >
                <i className="fa-solid fa-envelope"
                   style={{fontSize: '18px', width: '18px', textAlign: 'center'}}></i>
                <span className="align-middle" style={{fontSize: '15px'}}>{t('layout.menu.mailbox.index')}</span>
              </span>
              <ul id="documentation" className="sidebar-dropdown list-unstyled collapse show" data-bs-parent="#sidebar">
                <li className={`sidebar-item${
                    (pathname === '/mailbox/received' ||
                        pathname.includes('mailbox/received')) &&
                    ' active'
                }`}>
                  <NavLink
                      to="/mailbox/received"
                      className="sidebar-link"
                  >
                    <span className="align-middle" style={{fontSize: '15px'}}>{t('layout.menu.mailbox.received')}</span>
                  </NavLink>
                </li>
                <li className={`sidebar-item${
                    (pathname === '/mailbox/sent' ||
                        pathname.includes('mailbox/sent')) &&
                    ' active'
                }`}>
                  <NavLink
                      to="/mailbox/sent"
                      className="sidebar-link"
                  >
                    <span className="align-middle" style={{fontSize: '15px'}}>{t('layout.menu.mailbox.sent')}</span>
                  </NavLink>
                </li>
                <li className={`sidebar-item${
                    (pathname === '/mailbox/error' ||
                        pathname.includes('mailbox/error')) &&
                    ' active'
                }`}>
                  <NavLink
                      to="/mailbox/error"
                      className="sidebar-link"
                  >
                    <span className="align-middle" style={{fontSize: '15px'}}>{t('layout.menu.mailbox.error')}</span>
                  </NavLink>
                </li>
              </ul>
            </li>
          </ul>

        </div>
      </nav>
  )
};

export default Sidebar;
